import { FC, PropsWithChildren } from 'react';

export const AccordionContent: FC<PropsWithChildren<any>> = (props) => {
  return <div className="flex flex-col gap-6 py-6 pb-6 pl-8 pr-4 text-white">{props.children}</div>;
};
